module.exports = __webpack_public_path__ + "img/Nashville - Tiana and Liz House.ac6cf141.jpeg";